import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import ErrorContainer from './error-container'

let Header = ({ err, user, logout }) => (
  <div>
    <div>
      <nav className="navbar navbar-light bg-faded">
        <div className="container">
          <img src="https://static.da-io.net/images/da-logo.png"/>
          <Link className="navbar-brand" to="/login">DA Login</Link>
        </div>
      </nav>
      {
        user
        ? <div className="sub-nav">
            <div className="container">
              <nav className="nav nav-inline">
                <Link className="sub-nav__link nav-link" to="/emails">Emails</Link>
                <a href="#" className="sub-nav__link nav-link" onClick={logout}>Logout</a>
              </nav>
            </div>
          </div>
        : null
      }
    </div>
    <div className='p-t-1'>
      <ErrorContainer />
    </div>
  </div>
)

function mapStateToProps({user}) {
  return {
    user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logout: bindActionCreators(actions.logout, dispatch)
  }
}

Header = connect(mapStateToProps, mapDispatchToProps)(Header)

export default Header



// WEBPACK FOOTER //
// ./src/app/components/header.js